import React, { FC, MouseEvent } from 'react';
import * as Styles from './ProductCard.styles';

type BottomProductInfoProps = {
  isHover: boolean;
  showInfoDropdown: boolean;
  shouldShowDetailedInfo: boolean;
  features: string[];
  handleBottomInfoClick: (e: MouseEvent) => void;
};

export const BottomProductInfo: FC<BottomProductInfoProps> = ({
  isHover,
  showInfoDropdown,
  shouldShowDetailedInfo,
  features,
  handleBottomInfoClick,
}) => {
  const shouldDisplayFeature = (feature: string, features: string[]) => {
    const isSpecialFeature = /^[$]+|Residential|Commercial$/i.test(feature);
    const hasManyFeatures = features.length > 3;
    return !hasManyFeatures || isSpecialFeature;
  };

  return (
    <Styles.ProductInfoContainer
      activeScroll
      isHover={isHover}
      showContainedInfo={shouldShowDetailedInfo || !showInfoDropdown}
      onClick={handleBottomInfoClick}
    >
      <Styles.ProductInfoText variant="body" component="div">
        {features?.map((feature) => {
          if (!shouldDisplayFeature(feature, features)) {
            return null;
          }
          return (
            <Styles.FeatureItem key={String(feature)}>
              <small>{feature}</small>
              <br />
            </Styles.FeatureItem>
          );
        })}
      </Styles.ProductInfoText>
    </Styles.ProductInfoContainer>
  );
};
